import {SocialType} from "shared/SocialsShare/SocialsShare";
import React, {FC} from "react";

export interface SocialsList1Props {
  className?: string;
}

const socials: SocialType[] = [
  {
    name: "Facebook",
    icon: "lab la-facebook-square",
    href: "https://www.facebook.com/profile.php?id=61580045891832",
  },
  {
    name: "X",
    icon: "lab la-twitter-square",
    href: "https://x.com/beeappecuador?t=fbXENk10_l2OEfNfJhce4A&s=08",
  },
  {
    name: "Youtube",
    icon: "lab la-youtube",
    href: "https://www.youtube.com/@beeapp4228",
  },
  {
    name: "Instagram",
    icon: "lab la-instagram",
    href: "https://www.instagram.com/beeapp_ec?igsh=MXRlbHI4eG9rOGRpOA==",
  },
];

const SocialsList1: FC<SocialsList1Props> = ({className = "space-y-2.5"}) => {
  const renderItem = (item: SocialType, index: number) => {
    return (
      <a
        href={item.href}
        target="_blank"
        rel="noreferrer"
        className="flex items-center text-2xl text-neutral-700 hover:text-black dark:text-neutral-300 dark:hover:text-white leading-none space-x-2 group"
        key={index}
      >
        <i className={item.icon}></i>
        <span className="hidden lg:block text-sm">{item.name}</span>
      </a>
    );
  };

  return (
    <div className={`nc-SocialsList1 ${className}`} data-nc-id="SocialsList1">
      {socials.map(renderItem)}
    </div>
  );
};

export default SocialsList1;
